import { jsx as d } from "react/jsx-runtime";
import { idsLogger as n } from "../helpers.js";
const l = ({
  component: a,
  "data-testid": r,
  heading: e,
  headingText: t,
  HeadingTag: i = "h2"
}) => typeof e == "string" && e ? /* @__PURE__ */ d(i, { "data-testid": r, children: e }) : t ? (n(
  `${a}: 'headingLevel' and 'headingText' are deprecated and will be removed in a future version. Please use the new 'heading' prop instead.`
), /* @__PURE__ */ d(i, { "data-testid": r, children: t })) : e;
export {
  l as HeadingWithDeprecatedFallback
};
